import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectFade, Autoplay, Virtual } from 'swiper/modules';
import './index.css';
import 'swiper/css'
import 'swiper/css/pagination'


const Slider = ({ children, settings, className, onSlideChange }) => {
  const sliderOptions = {
    slidesPerView: 1,
    ...settings,
    onSlideChange: (swiper) => {
      if (onSlideChange) {
        onSlideChange(swiper.realIndex); 
      }
    },
  };
  return (
    <div className='slider-wrap'>
      <Swiper modules={[Pagination, EffectFade, Autoplay, Virtual]} className={className} {...sliderOptions} >
        {children}
      </Swiper>
    </div>
  );
};

export { SwiperSlide as Slide };
export default Slider;